import '../styles/List.css';
import '../styles/Notif.css';
import React, { useState, useEffect } from 'react';
import { LOGOUT_URL } from '../config';
import Tooltip from '@mui/material/Tooltip';
import { useLocation } from './AreaContext';
import { useNavigate } from 'react-router-dom';
import ClusterManager from './ClusterManager';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

const LeftMenu  = ({ view, jsonData, userData }) => {
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [showAboutModal, setShowAboutModal] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [showClusterManager, setShowClusterManager] = useState(false);
    const { selectedLocation } = useLocation(); 
    const [showGuides, setShowGuides] = useState(false);
    const [notificationsViewed, setNotificationsViewed] = useState(false);
    const [notifications] = useState([
    ]);
    
    const navigate = useNavigate();

    const openAboutModal = () => setShowAboutModal(true);
    const openLogoutModal = () => setShowLogoutModal(true);
    const closeLogoutModal = () => setShowLogoutModal(false);
    const closeWarningModal = () => setShowWarningModal(false);
    const closeAboutModal = () => setShowAboutModal(false);
    const openClusterManager = () => setShowClusterManager(true);
    const closeClusterManager = () => setShowClusterManager(false);

    const openWarningModal = () => {
        const latestTimestamp = Math.max(...notifications.map(n => new Date(n.timestamp).getTime()));
        localStorage.setItem('notificationsViewed', 'true');
        localStorage.setItem('lastSeenNotificationTimestamp', String(latestTimestamp));
        setNotificationsViewed(true);
        setShowWarningModal(true);
    };

    useEffect(() => {
        const viewed = localStorage.getItem('notificationsViewed') === 'true';
        setNotificationsViewed(viewed);
    }, []);

    useEffect(() => {
        const storedViewed = localStorage.getItem('notificationsViewed') === 'true';
        const lastSeen = parseInt(localStorage.getItem('lastSeenNotificationTimestamp') || '0', 10);
    
        if (notifications.length > 0 && storedViewed) {
            const maxTimestamp = Math.max(...notifications.map(n => new Date(n.timestamp).getTime()));
    
            if (maxTimestamp > lastSeen) {
                localStorage.setItem('notificationsViewed', 'false');
                setNotificationsViewed(false);
            }
        }
    }, [notifications]);

    const handleLogout = async () => {
        try {
            const response = await fetch(LOGOUT_URL, {
                method: 'POST',
                credentials: 'include',
            });

            if (response.ok) {
                window.location.href = '/';
            } else {
                console.error('Logout failed:', await response.json());
            }
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };

    const styles = {
        container: {
            height: '100%',
            width: '60px',
            position: 'fixed',
            left: '0',
            top: '0',
            zIndex: 10,
        },
        modal: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
            backgroundColor: '0px 0px 15px rgba(0,0,0,0.5)',
            padding: '20px',
        },
        modalContent: {
            textAlign: 'center',
        },
        modalButton: {
            margin: '6px',
            padding: '10px',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '0px',
        },
    };

    return (
        <div style={styles.container} className='left-menu-container'>
            <img src='images/vlara-logo-white.svg' alt='Logo' style={{width: '30px', margin: '15px', marginBottom: '10px', cursor: 'pointer', opacity: '0.9'}} onClick={() => navigate('/')}></img>
            <p className="amc-text-2">
                {selectedLocation?.toUpperCase()}
            </p>
            <p className="amc-text">
                {(view === "ATCView") ? "AMC" : ""}
            </p>
            <div className="button-stack">
                <Tooltip placement="right" title="Notifications" arrow>
                    <button className="icon-button warning-button" onClick={openWarningModal} 
                        style={{ position: 'relative', backgroundColor: notifications.length === 0 ? 'transparent' : '#db8300'}
                    }>
                        <img src="images/warning.svg" alt="Alert" />
                        {notifications.length > 0 && !notificationsViewed && (
                            <span className="notification-count">
                                {notifications.length}
                            </span>
                        )}
                    </button>
                </Tooltip>

                <Tooltip placement="right" title="Web Services Connection Status" arrow>
                    <button className="icon-button status-button" style={{ cursor: 'auto' }}>
                    <img src="images/check.svg" alt="Status" />
                    </button>
                </Tooltip>

                <Tooltip placement="right" title="User Guide" arrow>
                    <button className="icon-button info-button" onClick={() => setShowGuides(true)}>
                    <img src="images/help.svg" alt="Help" />
                    </button>
                </Tooltip>

                <Tooltip placement="right" title="About" arrow>
                    <button className="icon-button about-button" onClick={openAboutModal}>
                    <img src="images/info.svg" alt="About" />
                    </button>
                </Tooltip>

                {(
                    userData?.housekeeper?.split(',').map(loc => loc.trim()).includes(selectedLocation) || 
                    userData?.cid === '1339541' || 
                    userData?.cid === '10000004'
                ) && (
                    <Tooltip placement="right" title="Cluster Housekeeping" arrow>
                        <button className="icon-button setup-button" onClick={openClusterManager}>
                            <img src="images/setup.svg" alt="Setup" />
                        </button>
                    </Tooltip>
                )}

                <Tooltip placement="right" title="Logout from WBC" arrow>
                    <button className="icon-button logout-button" onClick={openLogoutModal}>
                    <img src="images/logout.svg" alt="Logout" />
                    </button>
                </Tooltip>
            </div>

            {/* Logout Confirmation Modal */}
            {showLogoutModal && (
                <div className="logout-modal" style={styles.modal}>
                    <div className="logout-modal-content" style={styles.modalContent}>
                        
                        <div className='about-modal' style={{justifyContent: 'center'}}>
                            <img src='images/logout.svg' alt='Logo' className='logout-modal-icon'/>
                            <h4>Logout</h4>
                        </div>

                        <p>Are you sure you would like to logout?</p>

                        <DialogActions style={{ justifyContent: 'center', gap: 10 }}>
                            <Button onClick={handleLogout} variant="contained" sx={{ borderRadius: 0}} color="error">
                                Logout
                            </Button>
                            <Button onClick={closeLogoutModal} variant="contained" sx={{ borderRadius: 0 }}>
                                Cancel
                            </Button>
                        </DialogActions>

                    </div>
                </div>
            )}

            {showWarningModal && (
                <>
                    <div className="notification-modal-overlay" onClick={closeWarningModal} />
                    <div className="notification-modal">

                        <div className='about-modal' style={{justifyContent: 'center'}}>
                            <img src='images/warning.svg' alt='Logo' style={{backgroundColor: '#db8300'}}/>
                            <h4>Notifications</h4>
                        </div>

                        {notifications.length === 0 ? (
                            <p style={{ textAlign: 'center' }}>No notifications found</p>
                        ) : (
                            notifications.map((notif) => (
                                <div key={notif.id} className="warning-item">
                                    <div className="timestamp">
                                    <span className="notif-id">{notif.id}</span>
                                    {notif.timestamp}
                                    </div>
                                    <div className="alert-modal-text" style={{fontWeight: 'bold'}}>{notif.title}</div>
                                    <div className="alert-modal-text">{notif.message}</div>
                                </div>
                            ))
                        )}
                        <DialogActions style={{ justifyContent: 'center' }}>
                            <Button onClick={closeWarningModal} variant="contained" sx={{ borderRadius: 0 }}>
                                Close
                            </Button>
                        </DialogActions>
                    </div>
                </>
            )}

            {showAboutModal && (
                <>
                    <div className="notification-modal-overlay" onClick={closeAboutModal} />
                    <div className="notification-modal" style={{width: '700px'}}>
                        <div className='about-modal'>
                            <img src='images/vlara-logo.svg' alt='Logo'></img>
                            <h4>About V-LARA</h4>
                        </div>
                        <div className='about-modal-content'>
                            <p>Lara Version</p>
                            <p>1.3.5</p>
                        </div>
                        <div className='about-modal-content'>
                            <p>Release Date</p>
                            <p>25/09/2026</p>
                        </div>
                        <div className='about-modal-content'>
                            <p>Redirect URL</p>
                            <p><a href='https://vats.im/vlara' target="_blank" rel="noopener noreferrer">vats.im/vlara</a></p>
                        </div>
                        <div className='about-modal-content'>
                            <p>Data Repository</p>
                            <p><a href='https://github.com/ottotuhkunen/virtual-lara-airspace-data/tree/main' target="_blank" rel="noopener noreferrer">GitHub Dev files</a></p>
                        </div>
                        <div className='about-modal-content'>
                            <p>Privacy Policy</p>
                            <p><a href='https://hold.lusep.fi/#/privacy-policy' target="_blank" rel="noopener noreferrer">privacy-policy</a></p>
                        </div>

                        <p style={{marginTop: '20px'}}>
                            V-LARA is a web-based tool for <span className='strong-text'>Simulating Airspace Reservations</span>, inspired by its real-life counterpart. It provides VATSIM controllers, pilots, and vSO organizations with interactive Area Reservations, combining features of the LARA Web Booking Client (WBC) and the Airspace Management Cell (AMC) Working Position into a single application.
                        </p>
                        <p>
                           Enjoy <span className='strong-text'>Seamless integration with the TopSky plugin</span> for realistic simulation of PREACTIVE and ACTIVE airspace blocks. Online ATCOs manage reservations within their AoR, as we don't have 24/7 AMC and NM coverage on VATSIM.
                        </p>
                        <DialogActions style={{ justifyContent: 'center', gap: 10 }}>
                            <Button onClick={() => { closeAboutModal(); window.location.hash = '#/dqt'; }} variant="contained" sx={{ borderRadius: 0 }} color="secondary">
                                <img src='images/dqt.svg' alt='Data Quality Tool' style={{height: '16px', marginRight: '8px'}}></img>Data Quality Tool
                            </Button>
                            <Button onClick={closeAboutModal} variant="contained" sx={{ borderRadius: 0 }}>
                                Close
                            </Button>
                        </DialogActions>

                    </div>
                </>
            )}

            {showGuides && (
                <Dialog open={showGuides} onClose={() => setShowGuides(false)}
                    sx={{ '& .MuiDialog-paper': { borderRadius: 0, textAlign: 'center', width: '300px'},}}
                >
                    <DialogTitle>V-LARA User Guide</DialogTitle>

                    <Button onClick={() => { window.open('https://wiki.vatsim-scandinavia.org/books/special-procedures/page/v-lara-atc-guide','_blank','noopener,noreferrer');}} variant="contained" sx={{ borderRadius: 0, margin: '5px 10px', justifyContent: 'flex-start' }} color="secondary">
                        <img src='images/document.svg' alt='User Guide' style={{height: '16px', marginRight: '8px'}}/>ATC Guide
                    </Button>
                    <Button onClick={() => { window.open('https://wiki.vatsim-scandinavia.org/books/finnish-airports-charts/page/v-lara-airspace-reservation','_blank','noopener,noreferrer');}} variant="contained" sx={{ borderRadius: 0, margin: '5px 10px', justifyContent: 'flex-start' }} color="secondary">
                        <img src='images/document.svg' alt='User Guide' style={{height: '16px', marginRight: '8px'}}/>Pilot Guide
                    </Button>

                    {jsonData?.pilotDocs && (
                        <Button onClick={() => { window.open(jsonData.pilotDocs,'_blank','noopener,noreferrer');}} variant="contained" sx={{ borderRadius: 0, margin: '5px 10px', justifyContent: 'flex-start' }} color="secondary">
                            <img src='images/document.svg' alt='User Guide' style={{height: '16px', marginRight: '8px'}}/>{selectedLocation} Local Guide
                        </Button>
                    )}

                    <DialogActions style={{ padding: '20px', justifyContent: 'center' }}>
                    <Button onClick={() => setShowGuides(false)} variant="contained" sx={{ borderRadius: 0 }}>
                        Close
                    </Button>
                    </DialogActions>
                </Dialog>
            )}

            {showClusterManager && (
               <ClusterManager
                showClusterManager={showClusterManager}
                closeClusterManager={closeClusterManager}
                selectedLocation={selectedLocation}
                userData={userData}
             />
            )}
                
        </div>
    );
};

export default LeftMenu;

/*
// Example notification
{ 
    id: 1,
    timestamp: '05 AUG 2025',
    title: 'Introduction of Data Quality Tool', 
    message: 'The Data Quality Tool (DQT) allows national Housekeepers to view and validate geojson airspace data before it is imported into LARA. Each cluster’s Housekeeper is responsible for ensuring the accuracy and completeness of the data. You can open DQT from the blue information button.', 
        
},
*/